import { FrontDoor } from "../components/FrontDoor";
import { useSession } from "../session/SessionContext";

/**
 * The front door. It is the only screen an operator sees before the API has
 * said anything about them, so it carries the mark and the one instruction
 * that matters: sign in with the address the access was granted to.
 *
 * The methods are Privy's to draw (email code and Google), which is why there
 * is one button here and not two. Apple is deliberately not among them: see
 * the `loginMethods` note in main.tsx. Someone who signed into the app with
 * Apple still gets in here with the code sent to that same address.
 */
export function SignIn() {
  const { login } = useSession();

  return (
    <FrontDoor
      title="Nerona Console"
      actions={
        <button type="button" className="primary" onClick={login}>
          Sign in
        </button>
      }
    >
      <p className="subtle">
        Internal tool for relationship managers and admins. Sign in with the
        email or Google account your access was granted to.
      </p>
    </FrontDoor>
  );
}
